import { application } from "./application"

import HelloController from "./hello_controller"
import MobileNavController from "./mobile_nav_controller"
application.register("hello", HelloController)
application.register("mobile-nav", MobileNavController)
